import { Spinner } from "flowbite-react";
export default Spinner;
